module.exports = __webpack_public_path__ + "static/media/step-one-small.dc786c3e.jpg";